import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function statesListReducer(
  state = initialState.statesList,
  action
) {
  switch (action.type) {
    case types.LOAD_STATES_SUCCESS:
      return action.statesList;
    default:
      return state;
  }
}
